<template>
  <component :is="getButtonStyle" :to="to" :href="href" class="button">
    <div v-if="showIcon">
      <svg
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        width="5.097"
        height="9"
        viewBox="0 0 5.097 9"
      >
        <path
          d="M4.275.255a.3.3,0,0,1,.45,0L8.56,4.6a.3.3,0,0,1-.225.5H.665A.3.3,0,0,1,.44,4.6Z"
          transform="translate(5.097) rotate(90)"
        />
      </svg>
    </div>
    <span><slot /></span>
  </component>
</template>

<script>
export default {
  props: {
    showIcon: {
      type: Boolean,
      default: true
    },
    to: {
      type: String,
      required: false,
      default: ''
    },
    href: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    getButtonStyle() {
      if (this.to !== '') {
        return 'nuxt-link';
      } else if (this.href !== '') {
        return 'a';
      } else {
        return 'button';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/foundation/_variables.scss';
.button {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: $color-white;
  background-color: $color-brand;
  margin: 15px auto 0;
  padding: 5px 10px;
  @media screen and (min-width: 960px) {
    max-width: 272px;
    height: 40px;
    padding: 5px 20px;
    transition: background-color 0.3s ease, opacity 0.3s ease;
    &:hover {
      background-color: $color-brand-hover;
    }
  }
  @media screen and (max-width: 959px) {
    height: 50px;
  }
  &:first-child {
    margin-top: 0;
  }
  &--weak {
    color: $color-brand;
    background-color: #ebeef1;
    @media screen and (min-width: 960px) {
      &:hover {
        background-color: #e7f3fa;
      }
    }
  }
  &--strong {
    background-color: #ee7b08;
    @media screen and (min-width: 960px) {
      &:hover {
        opacity: $opacity;
      }
    }
  }
  &--text {
    @media screen and (max-width: 959px) {
      margin-top: 23px;
      width: auto;
      height: auto;
      background: none;
      color: $color-brand;
    }
  }
  &--prev,
  &--next {
    padding: 0 30px;
    .icon {
      position: absolute;
      left: 10px;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
  &--prev {
    .icon {
      left: 10px;
      transform: rotate(180deg);
    }
  }
  &--next {
    .icon {
      right: 10px;
    }
  }
  span {
    display: inline-block;
  }
  .icon {
    flex-shrink: 0;
    width: 6px;
    height: 10px;
    margin-right: 7px;
  }
  &:disabled {
    background-color: #d1d4d7;
  }
  &--no-arrow {
    .icon {
      display: none;
    }
  }
}
.popup-notice .button {
  width: 290px;
  height: 51px;
}
</style>
